<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>
<section class="form-creation-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="form-wrapper">
          <div class="form-wrapper__header">
            <h2 data-translation-key="buyer_login_buyer_login_title">
              {{ 'buyer_login.buyer_login_title' | translate }}
            </h2>
          </div>

          <form [formGroup]="formData">
            <div class="input-container">
              <input
                #emailInput
                matInput
                type="email"
                class="input-field"
                formControlName="email"
                [placeholder]="'buyer_login.email' | translate"
                [ngClass]="{
                  'is-invalid':
                    formData.get('email')?.touched &&
                    formData.get('email')?.invalid
                }"
                data-translation-key="buyer_login_email"
                />
                @if (
                  formData.get('email')?.touched &&
                  formData.get('email')?.invalid
                  ) {
                  <div
                    class="input-feedback error"
                    >
                    @if (formData.get('email')?.hasError('required')) {
                      <div
                        data-translation-key="buyer_login_email_required"
                        >
                        {{ 'buyer_login.email_required' | translate }}
                      </div>
                    }
                    @if (formData.get('email')?.hasError('invalidEmail')) {
                      <div
                        data-translation-key="buyer_login_email_invalid"
                        >
                        {{ 'buyer_login.email_invalid' | translate }}
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="password-input-container">
                <div class="password-input-wrapper">
                  <input
                    matInput
                    [type]="showPassword ? 'text' : 'password'"
                    class="input-field"
                    formControlName="password"
                    [placeholder]="'buyer_login.password' | translate"
                  [ngClass]="{
                    'is-invalid':
                      formData.get('password')?.touched &&
                      formData.get('password')?.invalid
                  }"
                    data-translation-key="buyer_login_password"
                    />
                    <button
                      type="button"
                      class="toggle-password"
                      (click)="togglePasswordVisibility()"
                      >
                      <i
                        class="bi"
                        [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"
                      ></i>
                    </button>
                  </div>
                  @if (
                    formData.get('password')?.touched &&
                    formData.get('password')?.invalid
                    ) {
                    <div
                      class="input-feedback error"
                      >
                      @if (formData.get('password')?.hasError('required')) {
                        <div
                          data-translation-key="buyer_login_password_required"
                          >
                          {{ 'buyer_login.password_required' | translate }}
                        </div>
                      }
                    </div>
                  }
                </div>

                <div class="forgot-password">
                  <a
                    routerLink="/buyer/auth/forgot-password"
                    data-translation-key="buyer_login_buyer_login_forgot_your_password"
                    >
                    {{ 'buyer_login.buyer_login_forgot_your_password' | translate }}
                  </a>
                </div>

                <div class="form-buttons">
                  <button
                    (click)="onSubmit()"
                    type="submit"
                    class="btn btn-primary w-100 mb-4"
                    [disabled]="!formData.valid"
                    >
                    @if (submit_clicked) {
                      <div
                        class="d-flex justify-content-center"
                        >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </div>
                    }
                    @if (!submit_clicked) {
                      <span
                        data-translation-key="buyer_login_buyer_login_signin"
                        >
                        {{ 'buyer_login.buyer_login_signin' | translate }}
                      </span>
                    }
                  </button>
                </div>
              </form>

              <div class="signup-link">
                <span data-translation-key="buyer_login_first_time">{{ 'buyer_login.first_time' | translate }}</span>
                <a
                  routerLink="/buyer/auth/register"
                  data-translation-key="buyer_login_buyer_login_register_now"
                  >{{ 'buyer_login.buyer_login_register_now' | translate }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
